import { http } from "@client/shared/services";
import { responseFormatter } from "@client/utils";

const patch = (payload) => {
  return responseFormatter(
    http.patch(`/account`, payload, {
      setAuthHeader: true,
    })
  );
};

const Service = {
  patch,
};
export default Service;
